function smoothScroll(el, target, duration, dis) {
  const pos = target.getBoundingClientRect().top - dis
  const startTime = Date.now()
  const scrollFrom = el.scrollTop;
  const easing = (t,a,n,o) => {return 0==t?a:t==o?a+n:(t/=o/2)<1?n/2*Math.pow(2,10*(t-1))+a:n/2*(2-Math.pow(2,-10*--t))+a}
  (function loop() {
    const currentTime = Date.now() - startTime
    if (currentTime < duration) {
      scrollTo(0, easing(currentTime, scrollFrom, pos, duration))
      window.requestAnimationFrame(loop)
    } else {
      scrollTo(0, pos + scrollFrom)
    }
  })()
}

window.addEventListener('load', () => {
  const clicyboxesItems = document.querySelectorAll('.option--color .clickyboxes li a:not(.unavailable)')
  if (clicyboxesItems.length > 0) {
    clicyboxesItems.forEach(el => {
      el.addEventListener('click', () => {
        if (window.innerWidth < 768) {
          smoothScroll(document.scrollingElement, document.body, 300, 0)
        }
      })
    })
  }
})

window.addEventListener('load', () => {
  const customBtn = document.querySelector('.product-detail__form__action button[type="submit"]');
  if (customBtn && customBtn.textContent === '品切れ') {
    if (comingLabel) customBtn.textContent = 'COMING SOON'
  }
})
